<template>
  <div
    class="decision-engine d-flex flex-column i-px-12 i-py-11 align-items-center"
  >
    <div v-if="displayTabs" class="decision-engine-heading">
      <h3
        data-testid="decision-engine-heading-title"
        class="i-text-heading-3 i-text-neutral-120 i-mb-6"
      >
        Decision Engine
      </h3>
    </div>
    <div v-if="displayTabs" class="decision-engine-menu i-mb-12">
      <i-tabs
        :preselected-tab="currentSelectedTab"
        @tab-selected="onTabSelected"
      >
        <i-tab
          v-for="(tab, index) in tabs"
          :key="index"
          slot="tabs"
          :label="tab.label"
        ></i-tab>
      </i-tabs>
    </div>
    <div class="decision-engine-wrapper d-flex justify-content-center w-100">
      <div v-if="isOrgAdmin" class="decision-engine-page">
        <router-view @hide-tooltips="hideTooltips()" />
      </div>
      <empty-page v-else type="permission"></empty-page>
    </div>
    <i-toast></i-toast>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { iTab, iTabs, iToast, closeAllTooltips } from '@inscribe/signal';
import EmptyPage from '@/shared/components/EmptyPage.vue';

export default {
  components: { EmptyPage, iTab, iTabs, iToast },
  data: () => ({
    tabs: [
      {
        name: 'decision-engine-checks',
        label: 'Document Checks',
      },
      {
        name: 'decision-engine-rules',
        label: 'Fraud Rules',
      },
      {
        name: 'decision-engine-detectors',
        label: 'Fraud Detectors',
      },
      {
        name: 'decision-engine-blocklist',
        label: 'Blocklist',
      },
    ],
  }),
  computed: {
    ...mapGetters({
      isOrgAdmin: 'isOrgAdmin',
    }),
    currentSelectedTab() {
      return (
        this.tabs.findIndex((tab) => this.$route.name.startsWith(tab.name)) || 0
      );
    },
    displayTabs() {
      return ![
        'decision-engine-blocklist-edit',
        'decision-engine-checks-edit',
        'decision-engine-rule-edit',
      ].includes(this.$route.name);
    },
  },
  watch: {
    '$route.hash': function () {
      if (this.$route.hash) {
        this.scrollToSection(this.$route.hash);
      } else {
        document.querySelector('.app-wrapper').scrollTo(0, 0);
      }
    },
  },
  mounted() {
    if (this.isOrgAdmin) {
      this.getConfigRulesSchema();
    }
  },
  methods: {
    ...mapActions({
      getConfigRulesSchema: 'getConfigRulesSchema',
    }),
    onTabSelected(selectedIndex) {
      const selectedTab = this.tabs[selectedIndex];
      if (selectedTab) {
        this.$router.push({ name: selectedTab.name });
      }
    },
    scrollToSection(selector) {
      const element = document.querySelector(selector);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    },
    hideTooltips() {
      closeAllTooltips();
    },
  },
};
</script>

<style lang="scss" scoped>
$leftNavWidth: 240px;

.decision-engine {
  height: 100%;

  .decision-engine-wrapper {
    height: 100%;
  }

  :deep(.edit-container) {
    padding-top: 42px;
  }

  :deep(.edit-nav) {
    position: absolute;
    top: 0px;
    right: 0;
    left: $leftNavWidth;
    background: $light-neutral-default;
    z-index: 10;
  }

  &-view,
  &-heading,
  &-page,
  &-menu {
    width: 100%;
    max-width: 1200px;

    .more-link {
      display: none;
    }

    @include respond-to('large') {
      width: 100%;
      min-width: auto !important;

      .responsive-hide {
        display: none !important;
      }

      .more-link {
        display: list-item;
      }
    }

    :deep(.items-list) {
      $border-radius: 16px;

      border: 1px solid $light-neutral-60;

      .decision-engine-card {
        border-bottom: 1px solid $light-neutral-60;
        width: 100%;
      }

      .decision-engine-card:last-of-type {
        border-bottom: 0;
        border-bottom-left-radius: $border-radius;
        border-bottom-right-radius: $border-radius;
      }

      .decision-engine-card:first-of-type {
        border-top-left-radius: $border-radius;
        border-top-right-radius: $border-radius;
      }
    }
  }
}
</style>
